import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { LoginCard } from "@/components/admin/LoginCard";
import { LinksPanel } from "@/components/admin/LinksPanel";
import { UpcomingPanel } from "@/components/admin/UpcomingPanel";
import { ItemsPanel } from "@/components/admin/ItemsPanel";

const TABS = [["links", "Links"], ["upcoming", "Coming soon"], ["video", "Videos"], ["song", "Songs"], ["photo", "Photos"]];

export default function Admin() {
  const [user, setUser] = useState(null);
  const [content, setContent] = useState(null);
  const [tab, setTab] = useState("links");

  const load = () => api.get("/content").then(({ data }) => setContent(data)).catch(() => toast.error("Couldn't load content"));

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false));
  }, []);
  useEffect(() => {
    if (user) load();
  }, [user]);

  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };

  if (user === null) return <div className="min-h-screen bg-[var(--ink)]" />;
  if (!user) return <LoginCard onLogin={setUser} />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen px-4 py-8 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-5xl">
        <header className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img src="/mae-logo-ink.webp" alt="MAE" className="h-14 w-14 rounded-full" />
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--cash)]">Admin</p>
              <h1 className="font-display text-3xl uppercase">Money Alwayz Studio</h1>
            </div>
          </div>
          <div className="flex gap-2">
            <Link to="/" data-testid="admin-view-site" className="flex items-center gap-2 rounded-full border border-[var(--line)] px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] hover:border-[var(--cash)]"><ArrowLeft size={14} /> Site</Link>
            <button data-testid="admin-logout" onClick={logout} className="flex items-center gap-2 rounded-full border border-[var(--line)] px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] hover:border-red-400"><LogOut size={14} /> Log out</button>
          </div>
        </header>
        <nav className="mt-10 flex gap-2 overflow-x-auto pb-2">
          {TABS.map(([k, l]) => (
            <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)}
              className={`shrink-0 rounded-full px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] transition-colors ${tab === k ? "bg-[var(--cash)] text-[var(--ink)]" : "border border-[var(--line)] text-zinc-300 hover:border-zinc-400"}`}>{l}</button>
          ))}
        </nav>
        <div className="mt-8">
          {!content ? <p className="text-zinc-400">Loading…</p>
            : tab === "links" ? <LinksPanel links={content.links} onSaved={load} />
            : tab === "upcoming" ? <UpcomingPanel upcoming={content.upcoming} onSaved={load} />
            : <ItemsPanel key={tab} type={tab} items={content[`${tab}s`] ?? []} onChange={load} />}
        </div>
      </div>
    </div>
  );
}
